import { Navigate, Route, Routes } from 'react-router-dom';

import EntityTables from 'src/features/entity/components/EntityTables';
import EntityDashboard from 'src/features/entity/components/EntityDashboard';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { PERMISSION } from 'src/features/auth';

const EntitiesRoutes = () => {
    const permissionAccessEntities = useHasPermissions([PERMISSION.ACCESS_ENTITIES]);
    return (
        <Routes>
            {permissionAccessEntities && <Route path="" element={<EntityTables />} />}
            {permissionAccessEntities && <Route path=":type/:id" element={<EntityDashboard />} />}
            <Route path="*" element={<Navigate to=".." />} />
        </Routes>
    );
};

export default EntitiesRoutes;
